import { Path } from "react-native-svg";
import { createIcon } from "../Icon";

export const CameraFilledIcon = createIcon({
	viewBox: "0 0 24 24",
	path: (
		<>
			<Path
				d="M7.82422 4.28125L7.41797 5.5H4.5C3.12109 5.5 2 6.62109 2 8V18C2 19.3789 3.12109 20.5 4.5 20.5H19.5C20.8789 20.5 22 19.3789 22 18V8C22 6.62109 20.8789 5.5 19.5 5.5H16.582L16.1758 4.28125C15.9219 3.51563 15.207 3 14.3984 3H9.60156C8.79297 3 8.07812 3.51563 7.82422 4.28125ZM12 9.25C12.9946 9.25 13.9484 9.64509 14.6517 10.3483C15.3549 11.0516 15.75 12.0054 15.75 13C15.75 13.9946 15.3549 14.9484 14.6517 15.6516C13.9484 16.3549 12.9946 16.75 12 16.75C11.0054 16.75 10.0516 16.3549 9.34835 15.6516C8.64509 14.9484 8.25 13.9946 8.25 13C8.25 12.0054 8.64509 11.0516 9.34835 10.3483C10.0516 9.64509 11.0054 9.25 12 9.25Z"
				stroke="transparent"
			/>
		</>
	),
});
